import React, { useRef, useState } from 'react';

// material-ui
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  LinearProgress,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ScheduleIcon from '@mui/icons-material/Schedule';
import SyncAltIcon from '@mui/icons-material/SyncAlt';

// project imports

import {
  useAPSExtractFile,
  useAPSExtractFileCCT,
  useAPSExtractFormData,
  useAPSExtractIssues,
  useAPSExtractRFIs,
  useAPSExtractSubittals,
  useApsGetFormList,
  useApsGetHubs,
  useApsGetProjects,
  useExtractSchedule
} from '../../../hooks/useAps';
import useConnectionStore from '../../../store/useConnectors';
import useExtractStore from '../../../store/useExtract';
import ApsFolderContentDialog from '../../../components/autodesk/folderContent';
import { useSnackbar } from 'notistack';
import ScheduleFormDialog from '../../../components/scheduleDialog';

export default function HubPage({ closeDialog, setSnackbar }) {
  const payloadForm = useRef(null);
  const { enqueueSnackbar } = useSnackbar();
  const { connectionOwnerName, activeConnectionId } = useConnectionStore((s) => s);

  const { data: dataHubs, isFetching: isLoadingHubs, isError: isErrorHubs } = useApsGetHubs();
  const [projectId, setprojectId] = useState(0);
  const { mutate: extractIssues, isPending: isExtractingIssues, isSuccess: isSuccessIssues } = useAPSExtractIssues();
  const { mutate: extractRFIs, isPending: isExtractingRFIs, isSuccess: isSuccessRFIs } = useAPSExtractRFIs();
  const { mutate: extractSubmittals, isPending: isExtractingSubmittals, isSuccess: isSuccessSubmittals } = useAPSExtractSubittals();
  const { mutate: extractFormData, isPending: isExtractingFormData, isSuccess: isSuccessFormData } = useAPSExtractFormData();
  const { mutate: extractFiles, isPending: isExtractingFiles, isSuccess: isSuccessFiles } = useAPSExtractFile();
  const { mutate: extractFilesCCT, isPending: isExtractingFileCCT, isSuccess: isSuccessFileCCT } = useAPSExtractFileCCT();
  const { mutate: scheduleExtraction, isPending: isScheduleExtraction, isSuccess: isSuccessScheduleExtraction } = useExtractSchedule();

  const [openFolderDialog, setopenFolderDialog] = useState(false);
  const [typeOpenFolderDialog, settypeOpenFolderDialog] = useState("")
  const [openSchedule, setopenSchedule] = useState(false);

  const [idFormData, setidFormData] = useState('');
  const { refetch: fetchFormList, isFetching: isLoadingFormsList, isError: isErrorFormList } = useApsGetFormList(projectId);

  const [hubId, sethubId] = useState('');
  const { data: dataProjects, isFetching: isLoadingProjects, isError: isErrorProjects } = useApsGetProjects(hubId);

  const { setHubName, hubname, setOpenProject, openProject, setDataFormDetail, formDetail } = useExtractStore();

  const handleViewProjects = (data) => {
    // setviewProjects(true);
    setOpenProject(true);
    sethubId(data.id);
    setHubName(data.attributes?.name);
  };

  const [extractType, setextractType] = useState('');
  const [dataProject, setdataProject] = useState(null);

  const handleSelectExtract = (e, data, type) => {
    setAnchorEl(e.currentTarget);
    setdataProject(data);
    setextractType(type);
  };

  const handleExtractData = async (param) => {
    setAnchorEl(null);
    const data = dataProject;
    const type = extractType;
    const idProject = data?.relationships['issues'].data.id;
    setprojectId(idProject);
    const payload = {
      project_id: idProject.split('b.')[0],
      project_name: data.attributes.name,
      hub_name: hubname,
      hub_id: hubId,
      type,
      connection_id: activeConnectionId,
      connection_user_name: connectionOwnerName
    };
    console.log(payload);

    if (param === 'extract') {
      handleExtract(payload, type);
    }

    if (param === 'schedule') {
      setopenSchedule(true);
      payloadForm.current = payload;
    }

    if (param === 'auto') {
      // handleExtract(payload, type);
    }
  };

  const handleConfirmSchedule = (payload) => {
    setopenSchedule(false);
    scheduleExtraction(payload, {
      onSuccess: () => {
        closeDialog('success', "schedule");
      },
      onError: (error) => {
        setSnackbar({
          open: true,
          title: 'Create Schedule failed',
          content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
          type: 'error'
        });
      }
    });
  };

  const handleExtract = async (payload, type) => {
    const idProject = payload.project_id
    if (type === 'issues') {
      extractIssues(payload, {
        onSuccess: () => {
          closeDialog('success', type);
        },
        onError: (error) => {
          setSnackbar({
            open: true,
            title: 'Extract data failed',
            content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
            type: 'error'
          });
        }
      });
    }
    if (type === 'submittals') {
      extractSubmittals(payload, {
        onSuccess: () => {
          closeDialog('success', type);
        },
        onError: (error) => {
          setSnackbar({
            open: true,
            title: 'Extract data failed',
            content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
            type: 'error'
          });
        }
      });
    }
    if (type === 'rfis') {
      extractRFIs(payload, {
        onSuccess: () => {
          closeDialog('success', type);
        },
        onError: (error) => {
          setSnackbar({
            open: true,
            title: 'Extract data failed',
            content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
            type: 'error'
          });
        }
      });
    }
    if (type === 'forms') {
      // console.log({ idProject, formDetail });
      if (formDetail?.project_id == idProject) {
        handleOpenFormModal();
        payloadForm.current = payload;
      } else {
        enqueueSnackbar('No Form Detail available', {
          variant: 'warning'
        });
      }
    }
    if (type === 'formdetail') {
      await Promise.resolve();
      try {
        payloadForm.current = payload;
        const { data: forms,  } = await fetchFormList();
       
        if (forms?.length) {
          // console.log('forms', {forms, idProject});
          setDataFormDetail({
            project_id: idProject,
            data: forms
          });
          enqueueSnackbar('Forms loaded successfully', {
            variant: 'success'
          });
          // setOpenFormModal(true)
        } else {
          enqueueSnackbar('No forms available', {
            variant: 'warning'
          });
        }
      } catch (err) {
        enqueueSnackbar('Failed to load forms', {
          variant: 'error'
        });
      }
      return;
    }
    if (type === 'files') {
      setopenFolderDialog(true);
      settypeOpenFolderDialog(type);
      payloadForm.current = payload;
    }
    if (type === 'Concrete Cube Test') {
      setopenFolderDialog(true);
      settypeOpenFolderDialog(type);
      payloadForm.current = payload;
    }
  };

  const [openFormModal, setopenFormModal] = useState(false);

  const handleOpenFormModal = () => {
    setopenFormModal(true);
  };

  const handleCloseFormModal = (param) => {
    setopenFormModal(false);
    if (param === 'close') return false;
    if (!idFormData) return false;
    const payload = {
      ...payloadForm.current,
      templateId: idFormData
    };
    console.log(payload);
    extractFormData(payload, {
      onSuccess: () => {
        closeDialog('success', payloadForm.current.type);
      },
      onError: (error) => {
        setSnackbar({
          open: true,
          title: 'Extract data failed',
          content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
          type: 'error'
        });
      }
    });
  };

  const handleCloseFolderContent = (data) => {
    setopenFolderDialog(false);
    if (!data) return false;
    const payload = {
      ...payloadForm.current,
      file: data
    };
    console.log({payload, typeOpenFolderDialog});
    if (typeOpenFolderDialog == 'files') {
      extractFiles(payload, {
        onSuccess: () => {
          closeDialog('success', typeOpenFolderDialog);
        },
        onError: (error) => {
          setSnackbar({
            open: true,
            title: 'Extract data failed',
            content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
            type: 'error'
          });
        }
      });
    } else {
      extractFilesCCT(payload, {
        onSuccess: () => {
          closeDialog('success', typeOpenFolderDialog);
        },
        onError: (error) => {
          setSnackbar({
            open: true,
            title: 'Extract data failed',
            content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
            type: 'error'
          });
        }
      });
    }
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const isPageLoading = isLoadingHubs || isLoadingProjects;
  const isExtracting =
    isExtractingIssues ||
    isExtractingRFIs ||
    isExtractingSubmittals ||
    isExtractingFormData ||
    isExtractingFiles ||
    isExtractingFileCCT ||
    isScheduleExtraction || 
    isLoadingFormsList;

  return (
    <>
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={isExtracting}
        // onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box mt={5} px={1}>
        {isPageLoading && (
          <Box
            sx={{
              width: '100%'
            }}
          >
            <LinearProgress />
          </Box>
        )}
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: '35%' }}>
                  <strong>{openProject ? 'Project Name' : 'Hub Name'}</strong>
                </TableCell>
                <TableCell sx={{ width: '65%' }}>
                  <strong>Action</strong>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {!openProject &&
                dataHubs?.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell sx={{ width: '40%' }}>{row?.attributes?.name}</TableCell>

                    <TableCell sx={{ width: '60%' }}>
                      <Box>
                        <Button
                          sx={{ fontWeight: 'bold' }}
                          onClick={() => handleViewProjects(row)}
                          variant="outlined"
                          startIcon={<VisibilityOutlinedIcon />}
                        >
                          View Projects
                        </Button>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              {openProject &&
                dataProjects?.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>{row?.attributes?.name}</TableCell>

                    <TableCell>
                      <Stack direction={'row'} spacing={1}>
                        <Button
                          sx={{ fontWeight: 'bold' }}
                          endIcon={<KeyboardArrowDownIcon />}
                          onClick={(e) => handleSelectExtract(e, row, 'issues')}
                          variant="outlined"
                          //   startIcon={<VisibilityOutlinedIcon />}
                        >
                          Issues
                        </Button>
                        <Button
                          sx={{ fontWeight: 'bold' }}
                          endIcon={<KeyboardArrowDownIcon />}
                          onClick={(e) => handleSelectExtract(e, row, 'formdetail')}
                          variant="outlined"
                          //   startIcon={<VisibilityOutlinedIcon />}
                        >
                          Form Details
                        </Button>
                        <Button
                          sx={{ fontWeight: 'bold' }}
                          endIcon={<KeyboardArrowDownIcon />}
                          // onClick={(e) => setAnchorEl(e.currentTarget)}
                          onClick={(e) => handleSelectExtract(e, row, 'forms')}
                          variant="outlined"
                          //   startIcon={<VisibilityOutlinedIcon />}
                        >
                          Form Data
                        </Button>
                        <Button
                          sx={{ fontWeight: 'bold' }}
                          endIcon={<KeyboardArrowDownIcon />}
                          onClick={(e) => handleSelectExtract(e, row, 'submittals')}
                          variant="outlined"
                          //   startIcon={<VisibilityOutlinedIcon />}
                        >
                          Submittal
                        </Button>
                        <Button
                          sx={{ fontWeight: 'bold' }}
                          endIcon={<KeyboardArrowDownIcon />}
                          onClick={(e) => handleSelectExtract(e, row, 'rfis')}
                          variant="outlined"
                          //   startIcon={<VisibilityOutlinedIcon />}
                        >
                          RFIs
                        </Button>
                        <Button
                          sx={{ fontWeight: 'bold' }}
                          endIcon={<KeyboardArrowDownIcon />}
                          onClick={(e) => handleSelectExtract(e, row, 'files')}
                          variant="outlined"
                          //   startIcon={<VisibilityOutlinedIcon />}
                        >
                          Files
                        </Button>
                        <Button
                          sx={{ fontWeight: 'bold' }}
                          endIcon={<KeyboardArrowDownIcon />}
                          onClick={(e) => handleSelectExtract(e, row, 'Concrete Cube Test')}
                          variant="outlined"
                          //   startIcon={<VisibilityOutlinedIcon />}
                        >
                          CCT Files
                        </Button>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog open={openFormModal} onClose={() => handleCloseFormModal('close')}>
          <DialogTitle>Select a Form</DialogTitle>
          <DialogContent>
            <DialogContentText>Available Form</DialogContentText>
            <Box sx={{ width: '25vw', mt: 3 }}>
              {/* <form onSubmit={handleSubmit} id="subscription-form"> */}
              <TextField
                fullWidth
                id="outlined-select-currency"
                select
                label="Select Type"
                defaultValue="all"
                value={idFormData}
                onChange={(e) => setidFormData(e.target.value)}
              >
                {projectId &&
                  formDetail?.data?.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option?.name}
                    </MenuItem>
                  ))}
              </TextField>
              {/* </form> */}
              <Button
                onClick={() => handleCloseFormModal('submit')}
                sx={{ mt: 3, fontWeight: 'bold' }}
                fullWidth
                variant="contained"
                form="subscription-form"
              >
                SUBMIT
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={() => handleExtractData('extract')}>
          <ListItemIcon>
            <UploadFileIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Extract Data" />
        </MenuItem>

        <MenuItem onClick={() => handleExtractData('schedule')}>
          <ListItemIcon>
            <ScheduleIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Schedule Extraction" />
        </MenuItem>

        <MenuItem onClick={() => handleExtractData('auto')}>
          <ListItemIcon>
            <SyncAltIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Automatic Extraction" />
        </MenuItem>
      </Menu>

      {openFolderDialog && (
        <ApsFolderContentDialog
          open={openFolderDialog}
          data={payloadForm.current}
          onClose={() => setopenFolderDialog(false)}
          onConfirm={(param) => handleCloseFolderContent(param)}
        />
      )}

      <ScheduleFormDialog
        data={payloadForm.current}
        open={openSchedule}
        onClose={() => setopenSchedule(false)}
        onConfirm={handleConfirmSchedule}
      />
    </>
  );
}
